// @ts-nocheck
import React, { memo, useState, useEffect, useRef, useMemo } from "react";
import { useMutation } from "react-query";
import { useRouter } from "next/router";
import Image from "next/image";

import { baseGetRequest } from "utils/api/api";
import { questEventsListUrl } from "utils/api/requestUrls";

import {
  Review,
  BookingSchedule,
  QuestInfo,
  QuestStatistic,
  PageWrapper,
  RecomendedQuests,
} from "components";

import { Link, animateScroll as scroll } from "react-scroll";

import _ from "lodash";
import ImageGallery from "react-image-gallery";

import styles from "./QuizContainer.module.scss";

import { createStyles, makeStyles } from "@material-ui/core/styles";

import Divider from "@material-ui/core/Divider";

import GiveModal from "modals/GiveModal";
import SuccessModal from "modals/SuccessModal";
import ReviewModal from "modals/ReviewModal";
import classNames from "classnames";
import "react-image-gallery/styles/css/image-gallery.css";

const useStyles = makeStyles(() =>
  createStyles({
    divider: {
      backgroundColor: "#472F66",
      width: "100%",
      marginTop: 15,
      marginBottom: 10,
    },
    listDivider: {
      width: "5px",
      height: "10%",
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "10px",
      marginRight: "10px",
      paddingTop: "4px",
      borderBottom: "5px dotted white",
    },
    genreList: {
      listStyle: "none",
      display: "flex",
      flexWrap: "wrap",
      flexDirection: "row",
      padding: 0,
      justifyContent: "center",
    },
    showText: {
      "&:target": {
        display: "none",
      },
    },
    questImage: {
      width: "31%",
      display: "inline-block",
      marginTop: "0.5rem",
      marginLeft: "5px",
      marginRight: "5px",
      borderRadius: "10px",
      ["@media (max-width:1020px)"]: {
        width: "46%",
      },
    },
    loadingScreen: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      flexShrink: 0,
      height: "calc(100vh - 144px - 73px)",
      padding: "0 10px",
    },
  })
);

const QuizContainer = (props: any) => {
  const classes = useStyles();
  const router = useRouter();
  const bookingRef = useRef();

  const pageView = (event) => {
    window &&
      window.dataLayer &&
      window.dataLayer.push({
        event: event,
      });
  };

  useEffect(() => {
    if (router?.query?.block === "booking") {
      bookingRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const {
    quizId,
    quizName,
    questFirstData,
    questEventsFirstData,
    reviewsFirstData,
    statisticFirstData,
    overallRating,
    questListFirstData,
    responseBody,
  } = props;

  const [data, setData] = useState(responseBody);
  const [prevQuestCounts, setPrevQuestCounts] = useState(0);
  const [nextQuestCounts, setNextQuestCounts] = useState(7);
  const [showBookingModal, setShowBookingModal] = useState<boolean>(false);

  const sortableQuestsSlice = useMemo(
    () => data.slice(prevQuestCounts, nextQuestCounts),
    [nextQuestCounts, prevQuestCounts]
  );

  useEffect(() => {
    setData(responseBody);
  }, [responseBody]);

  const setNextBookingList = () => {
    setNextQuestCounts((prevState) => prevState + 7);
  };

  const [showGiveModal, setShowGiveModal] = useState<boolean>(false);
  const [showReviewModal, setShowReviewModal] = useState<boolean>(false);
  const [isSuccessBooking, setIsSuccessBooking] = useState<boolean>(false);
  const [isSuccessSertificate, setIsSuccessSertificate] =
    useState<boolean>(false);
  const [isSuccessReview, setIsSuccessReview] = useState<boolean>(false);
  const [schelduleList, setSchelduleList] = useState([]);

  const setClodeModal = (value) => {
    if (value) {
      setIsSuccessBooking(value);
    } else {
      setIsSuccessBooking(value);
    }
  };

  const changeBookingState = (value: any) => {
    router.push("/thank-you-booking");
  };

  function onShowReviewsClick() {
    router.push(
      {
        pathname: `/kvest/${quizId}/otzyvy`,
        query: { quizName: quizName },
      },
      `/kvest/${quizId}/otzyvy`
    );
  }

  const { mutate: getBookingData, isLoading: getBookingDataLoading } =
    useMutation(() => baseGetRequest(questEventsListUrl(quizId)), {
      onSuccess: (res) => {
        if (!!res?.content?.length) {
          setData(Object.values(_.groupBy(res?.content, "startDate")));
          setShowBookingModal(false);
          setIsSuccessBooking(true);
        }
      },
      onError: (err) => {
        setShowBookingModal(false);
        console.warn("error", err);
      },
    });

  const {
    name,
    description,
    address,
    questPrices,
    images,
    genres,
    difficulty,
    horror,
    duration,
    countOfPlayersInfo,
    ageInfo,
    withActors,
    imageFilePath,
  } = questFirstData;

  const NewImages = images.map((item) => ({
    original: item.imagePath,
    thumbnail: item.imagePath,
  }));

  return (
    <>
      <PageWrapper>
        <div
          className={
            "flex flex-col items-center md:py-6 lg:py-12 xl:py-12 sm:py-2 min-h-screen sm:mb-5"
          }
        >
          <div
            className={
              "flex sm:flex-col items-top justify-between w-full h-auto text-center text-white mb-1"
            }
          >
            <div
              className={
                "flex flex-col justify-start w-full md:w-full sm:w-full h-auto"
              }
            >
              <div className={styles.QuestWrapperInfo}>
                <div className={styles.MainImageQuestWrapper}>
                  <Image
                    className={styles.MainImageQuest}
                    loader={() => imageFilePath}
                    src={imageFilePath}
                    layout="fill"
                    alt={`123`}
                  />
                </div>

                <div className={styles.Tfsdo}>
                  <div className={styles.QuestWrapperInfoHeader}>
                    <div className={styles.RaitingWrapper}>
                      <Image
                        src="/icons/star.svg"
                        alt="address icon"
                        width={20}
                        height={20}
                      />
                      {overallRating}
                    </div>
                    <div>
                      <div className={styles.DificultiWrapper}>
                        {difficulty >= 1 ? (
                          <Image
                            src={
                              !horror ? "/icons/lock.svg" : "/icons/horror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <Image
                            src={
                              !horror
                                ? "/icons/grayLock.svg"
                                : "/icons/grayHorror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        )}
                        {difficulty >= 2 ? (
                          <Image
                            src={
                              !horror ? "/icons/lock.svg" : "/icons/horror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <Image
                            src={
                              !horror
                                ? "/icons/grayLock.svg"
                                : "/icons/grayHorror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        )}
                        {difficulty >= 3 ? (
                          <Image
                            src={
                              !horror ? "/icons/lock.svg" : "/icons/horror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <Image
                            src={
                              !horror
                                ? "/icons/grayLock.svg"
                                : "/icons/grayHorror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        )}
                        {difficulty >= 4 ? (
                          <Image
                            src={
                              !horror ? "/icons/lock.svg" : "/icons/horror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <Image
                            src={
                              !horror
                                ? "/icons/grayLock.svg"
                                : "/icons/grayHorror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        )}
                        {difficulty >= 5 ? (
                          <Image
                            src={
                              !horror ? "/icons/lock.svg" : "/icons/horror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <Image
                            src={
                              !horror
                                ? "/icons/grayLock.svg"
                                : "/icons/grayHorror.svg"
                            }
                            alt="address icon"
                            width={20}
                            height={20}
                          />
                        )}
                      </div>
                    </div>
                  </div>

                  <div className={styles.QuestNameTitle}>{name}</div>
                  <div className={styles.QuestAddress}>
                    <Image
                      src="/icons/address.svg"
                      alt="address icon"
                      width={"20"}
                      height={"20"}
                    />
                    <span>{address}</span>
                  </div>

                  <div className={styles.CardQuestInfo}>
                    <div className={styles.CardQuestInfoBlock}>
                      <div className={styles.CardQuestInfoBlockItem}>
                        <Image
                          src="/icons/clock.svg"
                          alt="address icon"
                          width={"20"}
                          height={"20"}
                        />
                        <span> {duration}</span>
                      </div>
                      <div className={styles.CardQuestInfoBlockItem}>
                        <Image
                          src="/icons/people.svg"
                          alt="address icon"
                          width={"20"}
                          height={"20"}
                        />
                        <span>{countOfPlayersInfo} человек</span>
                      </div>
                    </div>

                    <div className={styles.CardQuestInfoBlock}>
                      <div className={styles.CardQuestInfoBlockItem}>
                        <Image
                          src="/icons/age.svg"
                          alt="address icon"
                          width={"20"}
                          height={"20"}
                        />
                        <span>от {ageInfo?.replace("+", "")} лет</span>
                      </div>
                      <div className={styles.CardQuestInfoBlockItem}>
                        <Image
                          src="/icons/horror.svg"
                          alt="address icon"
                          width={20}
                          height={20}
                        />
                        <span>{withActors ? "С актером" : "Без актера"}</span>
                      </div>
                    </div>
                  </div>

                  <div className={styles.ButtonWrapper}>
                    <Link
                      to="booking"
                      smooth={true}
                      className={styles.ButtonBooking}
                    >
                      Забронировать
                    </Link>

                    <div
                      onClick={() => setShowGiveModal(true)}
                      className={styles.ButtonGift}
                    >
                      Подарить
                    </div>
                  </div>
                </div>
              </div>

              <div className={"w-auto text-left"}>
                <div className={styles.QuestBlockInfo} id="description">
                  <div className={styles.QuestBlockTitle}>Описание</div>
                  <pre className={styles.QuestDescription}>{description}</pre>

                  <QuestInfo {...props} genres={genres} address={address} />
                </div>
              </div>
            </div>
          </div>
          <div
            id={"booking"}
            ref={bookingRef}
            className={
              "flex flex-col items-start justify-start w-full text-left text-white"
            }
          >
            <Divider className={classes.divider} variant="fullWidth" />
            <div className={styles.BookingTextWrapper}>
              <div className={styles.BookingTextTitle}>
                Расписание и бронирование
              </div>
            </div>
            <div className={styles.BookingTextDescription}>
              Цена указана за команду
            </div>
            <div className={styles.BookingContainer}>
              <BookingSchedule
                {...{
                  schedule: sortableQuestsSlice,
                  prices: questPrices,
                  questName: name,
                  questId: quizId,
                  changeBookingState: changeBookingState,
                  address,
                  pageView: pageView,
                  use: "quiz",
                  questFirstData,
                  getBookingData: getBookingData,
                  getBookingDataLoading: getBookingDataLoading,
                  showBookingModal: showBookingModal,
                  setShowBookingModal: setShowBookingModal,
                }}
              />
            </div>
            {nextQuestCounts <= sortableQuestsSlice?.length && (
              <div className={styles.BookingSelectButtonWrapper}>
                <div
                  className={styles.BookingSelectButton}
                  onClick={setNextBookingList}
                >
                  <div className={styles.BookingSelectButtonText}>
                    Загрузить еще
                  </div>
                </div>
              </div>
            )}
          </div>

          {images?.length > 0 && (
            <>
              <Divider className={classes.divider} variant="fullWidth" />
              <div className={styles.Photos} id="photos">
                <div className={styles.PhotosTitle}>Галерея</div>
                <ImageGallery
                  items={NewImages}
                  originalHeight={200}
                  autoPlay={true}
                  thumbnailPosition="right"
                  showFullscreenButton={false}
                />
              </div>
            </>
          )}
          <Divider className={classes.divider} variant="fullWidth" />
          <div className={"text-2xl flex flex-col mt-8 sm:mt-0"} id="reviews">
            <div className={styles.PhotosTitle}>Отзывы</div>

            <div className={styles.Statictic}>
              <div className={styles.ReviewOveralWrapper}>
                <div className={styles.ReviewOveralNumber}>{overallRating}</div>
                <div className={styles.ReviewOveralStars}>
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 1
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 2
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 3
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 4
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 5
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 6
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 7
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 8
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 9
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                  <Image
                    src={
                      overallRating?.toFixed(0) >= 10
                        ? "/icons/star.svg"
                        : "/icons/startDisabled.svg"
                    }
                    alt="address icon"
                    width={20}
                    height={20}
                  />
                </div>
              </div>
              <QuestStatistic {...props} />
            </div>

            {reviewsFirstData?.length ? (
              reviewsFirstData?.map((item, i) => (
                <>
                  {i < 4 ? (
                    <Review
                      name={item.client.name}
                      text={item.review}
                      date={item.visitDate}
                      overallRating={item.overallRating}
                      galochka={item.galochka}
                    />
                  ) : null}
                </>
              ))
            ) : (
              <div
                className={
                  "flex flex-col items-center justify-center h-40 text-md text-gray-600"
                }
              >
                Отзывов еще нет
                <div className={"text-sm"}>
                  Вы можете оставить нам первый отзыв
                </div>
              </div>
            )}
            <div className={styles.ReviesButtonWrapper}>
              <a
                className={styles.ReviesButtonShowMoreReview}
                onClick={onShowReviewsClick}
              >
                <Image
                  src="/icons/showMore.svg"
                  alt="address icon"
                  width={25}
                  height={24}
                />
                <span>Показать еще отзывы</span>
              </a>
              <div
                className={styles.ReviesButtonSendReview}
                onClick={() => setShowReviewModal(!showReviewModal)}
              >
                Оставить отзыв
              </div>
            </div>
          </div>

          {showGiveModal ? (
            <GiveModal
              setOpen={setShowGiveModal}
              isOpen={true}
              questGiveData={questFirstData}
              setIsSuccessSertificate={setIsSuccessSertificate}
            />
          ) : null}

          {isSuccessBooking ? (
            <SuccessModal
              {...{
                isOpen: isSuccessBooking,
                setOpen: setClodeModal,
                icon: "/icons/success.svg",
                description:
                  "Для отмены бронирования, пожалуйста, свяжитесь с нами!",
                title: `Квест "${name}" успешно забронирован!`,
                id: quizId,
              }}
            />
          ) : null}

          {isSuccessSertificate ? (
            <SuccessModal
              {...{
                isOpen: isSuccessSertificate,
                setOpen: setIsSuccessSertificate,
                icon: "/icons/success.svg",
                description:
                  "В ближайшее время мы свяжемся с вами по указанному номеру телефона!",
                title: `Заявка успешно отправлена!`,
                id: quizId,
              }}
            />
          ) : null}

          {isSuccessReview ? (
            <SuccessModal
              {...{
                isOpen: isSuccessReview,
                setOpen: setIsSuccessReview,
                icon: "/icons/success.svg",
                description: "После модерации ваш отзыв будет опубликован!",
                title: `Отзыв успешно отправлен!`,
                id: quizId,
              }}
            />
          ) : null}

          {showReviewModal ? (
            <ReviewModal
              {...{
                isOpen: showReviewModal,
                setOpen: setShowReviewModal,
                title: name,
                quizId,
                setIsSuccessReview: setIsSuccessReview,
              }}
            />
          ) : null}
        </div>
      </PageWrapper>
      <RecomendedQuests questListFirstData={questListFirstData.content} />
    </>
  );
};

export default memo(QuizContainer);
